/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  AppointmentAvailabilities,
  AppointmentRequest,
  AppointmentResponse,
  AppointmentType,
  CheckAppointmentDurationResponse,
  CheckAppointmentResponse,
  NextAppointmentTypeAvailability,
  PlanningPermissionResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AppointmentAvailabilitiesFromJSON,
    AppointmentAvailabilitiesToJSON,
    AppointmentRequestFromJSON,
    AppointmentRequestToJSON,
    AppointmentResponseFromJSON,
    AppointmentResponseToJSON,
    AppointmentTypeFromJSON,
    AppointmentTypeToJSON,
    CheckAppointmentDurationResponseFromJSON,
    CheckAppointmentDurationResponseToJSON,
    CheckAppointmentResponseFromJSON,
    CheckAppointmentResponseToJSON,
    NextAppointmentTypeAvailabilityFromJSON,
    NextAppointmentTypeAvailabilityToJSON,
    PlanningPermissionResponseFromJSON,
    PlanningPermissionResponseToJSON,
} from '../models/index';

export interface AddAppointmentRequest {
    instituteId: string;
    appointmentRequest: AppointmentRequest;
}

export interface CheckAppointmentDurationRequest {
    instituteId: string;
    date?: string;
    time?: string;
    doctorId?: string;
    appointmentTypeId?: string;
    duration?: number;
}

export interface CheckAppointmentExistRequest {
    instituteId: string;
    appointmentDate?: string;
    appointmentTime?: string;
    duration?: number;
    doctorId?: string;
    appointmentId?: string;
}

export interface DeleteAppointmentRequest {
    instituteId: string;
    appointmentId: string;
}

export interface GetAppointmentTypeNextAvailabilityRequest {
    instituteId: string;
    doctorId: string;
    startDate: string;
    appointmentTypeId: string;
}

export interface GetAppointmentTypesRequest {
    instituteId: string;
    doctorId: string;
}

export interface GetDoctorAvailabilitiesRequest {
    instituteId: string;
    doctorId: string;
    startDate: string;
    dayNumber: number;
    duration?: number;
}

export interface GetPlanningHealthProListRequest {
    instituteId: string;
}

export interface ListAppointmentsByPeriodRequest {
    instituteId: string;
    periodStart?: string;
    periodEnd?: string;
    doctor?: string;
    appointmentType?: string;
    displayPeriodPast?: boolean;
    isPatientWithoutAppointment?: boolean;
}

export interface UpdateAppointmentRequest {
    instituteId: string;
    appointmentId: string;
    appointmentRequest: AppointmentRequest;
    isMove?: boolean;
}

/**
 * 
 */
export class PlanningApi extends runtime.BaseAPI {

    /**
     * Add an appointment for an institute
     */
    async addAppointmentRaw(requestParameters: AddAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling addAppointment().'
            );
        }

        if (requestParameters['appointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentRequest',
                'Required parameter "appointmentRequest" was null or undefined when calling addAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentRequestToJSON(requestParameters['appointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Add an appointment for an institute
     */
    async addAppointment(requestParameters: AddAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.addAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if appointment duration is too long for the planning
     */
    async checkAppointmentDurationRaw(requestParameters: CheckAppointmentDurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckAppointmentDurationResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling checkAppointmentDuration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = requestParameters['date'];
        }

        if (requestParameters['time'] != null) {
            queryParameters['time'] = requestParameters['time'];
        }

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctorId'] = requestParameters['doctorId'];
        }

        if (requestParameters['appointmentTypeId'] != null) {
            queryParameters['appointmentTypeId'] = requestParameters['appointmentTypeId'];
        }

        if (requestParameters['duration'] != null) {
            queryParameters['duration'] = requestParameters['duration'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning/check-duration`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckAppointmentDurationResponseFromJSON(jsonValue));
    }

    /**
     * Check if appointment duration is too long for the planning
     */
    async checkAppointmentDuration(requestParameters: CheckAppointmentDurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckAppointmentDurationResponse> {
        const response = await this.checkAppointmentDurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if an appointment already exist for the same period and doctor
     */
    async checkAppointmentExistRaw(requestParameters: CheckAppointmentExistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckAppointmentResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling checkAppointmentExist().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['appointmentDate'] != null) {
            queryParameters['appointmentDate'] = requestParameters['appointmentDate'];
        }

        if (requestParameters['appointmentTime'] != null) {
            queryParameters['appointmentTime'] = requestParameters['appointmentTime'];
        }

        if (requestParameters['duration'] != null) {
            queryParameters['duration'] = requestParameters['duration'];
        }

        if (requestParameters['doctorId'] != null) {
            queryParameters['doctorId'] = requestParameters['doctorId'];
        }

        if (requestParameters['appointmentId'] != null) {
            queryParameters['appointmentId'] = requestParameters['appointmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning/check-appointment`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckAppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Check if an appointment already exist for the same period and doctor
     */
    async checkAppointmentExist(requestParameters: CheckAppointmentExistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckAppointmentResponse> {
        const response = await this.checkAppointmentExistRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an appointment
     */
    async deleteAppointmentRaw(requestParameters: DeleteAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling deleteAppointment().'
            );
        }

        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling deleteAppointment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning/{appointment_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"appointment_id"}}`, encodeURIComponent(String(requestParameters['appointmentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Delete an appointment
     */
    async deleteAppointment(requestParameters: DeleteAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.deleteAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the next availabilities of a doctor from a date for an appointment type
     */
    async getAppointmentTypeNextAvailabilityRaw(requestParameters: GetAppointmentTypeNextAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NextAppointmentTypeAvailability>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getAppointmentTypeNextAvailability().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getAppointmentTypeNextAvailability().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getAppointmentTypeNextAvailability().'
            );
        }

        if (requestParameters['appointmentTypeId'] == null) {
            throw new runtime.RequiredError(
                'appointmentTypeId',
                'Required parameter "appointmentTypeId" was null or undefined when calling getAppointmentTypeNextAvailability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['appointmentTypeId'] != null) {
            queryParameters['appointmentTypeId'] = requestParameters['appointmentTypeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/doctors/{doctor_id}/next-availability`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NextAppointmentTypeAvailabilityFromJSON(jsonValue));
    }

    /**
     * Get the next availabilities of a doctor from a date for an appointment type
     */
    async getAppointmentTypeNextAvailability(requestParameters: GetAppointmentTypeNextAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NextAppointmentTypeAvailability> {
        const response = await this.getAppointmentTypeNextAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the active appointment types of a doctor in an institute
     */
    async getAppointmentTypesRaw(requestParameters: GetAppointmentTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentType>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getAppointmentTypes().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getAppointmentTypes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/doctors/{doctor_id}/appointment-types`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentTypeFromJSON));
    }

    /**
     * Get the active appointment types of a doctor in an institute
     */
    async getAppointmentTypes(requestParameters: GetAppointmentTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentType>> {
        const response = await this.getAppointmentTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the availabilities of a doctor from a date
     */
    async getDoctorAvailabilitiesRaw(requestParameters: GetDoctorAvailabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentAvailabilities>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getDoctorAvailabilities().'
            );
        }

        if (requestParameters['doctorId'] == null) {
            throw new runtime.RequiredError(
                'doctorId',
                'Required parameter "doctorId" was null or undefined when calling getDoctorAvailabilities().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getDoctorAvailabilities().'
            );
        }

        if (requestParameters['dayNumber'] == null) {
            throw new runtime.RequiredError(
                'dayNumber',
                'Required parameter "dayNumber" was null or undefined when calling getDoctorAvailabilities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = requestParameters['startDate'];
        }

        if (requestParameters['dayNumber'] != null) {
            queryParameters['dayNumber'] = requestParameters['dayNumber'];
        }

        if (requestParameters['duration'] != null) {
            queryParameters['duration'] = requestParameters['duration'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/doctors/{doctor_id}/availabilities`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"doctor_id"}}`, encodeURIComponent(String(requestParameters['doctorId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentAvailabilitiesFromJSON));
    }

    /**
     * Get the availabilities of a doctor from a date
     */
    async getDoctorAvailabilities(requestParameters: GetDoctorAvailabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentAvailabilities>> {
        const response = await this.getDoctorAvailabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get planning healthpro list for current user
     */
    async getPlanningHealthProListRaw(requestParameters: GetPlanningHealthProListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlanningPermissionResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling getPlanningHealthProList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning/health-pro`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PlanningPermissionResponseFromJSON));
    }

    /**
     * Get planning healthpro list for current user
     */
    async getPlanningHealthProList(requestParameters: GetPlanningHealthProListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlanningPermissionResponse>> {
        const response = await this.getPlanningHealthProListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all appointments for an institute and period
     */
    async listAppointmentsByPeriodRaw(requestParameters: ListAppointmentsByPeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppointmentResponse>>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling listAppointmentsByPeriod().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['periodStart'] != null) {
            queryParameters['periodStart'] = requestParameters['periodStart'];
        }

        if (requestParameters['periodEnd'] != null) {
            queryParameters['periodEnd'] = requestParameters['periodEnd'];
        }

        if (requestParameters['doctor'] != null) {
            queryParameters['doctor'] = requestParameters['doctor'];
        }

        if (requestParameters['appointmentType'] != null) {
            queryParameters['appointmentType'] = requestParameters['appointmentType'];
        }

        if (requestParameters['displayPeriodPast'] != null) {
            queryParameters['displayPeriodPast'] = requestParameters['displayPeriodPast'];
        }

        if (requestParameters['isPatientWithoutAppointment'] != null) {
            queryParameters['isPatientWithoutAppointment'] = requestParameters['isPatientWithoutAppointment'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppointmentResponseFromJSON));
    }

    /**
     * Lists all appointments for an institute and period
     */
    async listAppointmentsByPeriod(requestParameters: ListAppointmentsByPeriodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppointmentResponse>> {
        const response = await this.listAppointmentsByPeriodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an appointment
     */
    async updateAppointmentRaw(requestParameters: UpdateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppointmentResponse>> {
        if (requestParameters['instituteId'] == null) {
            throw new runtime.RequiredError(
                'instituteId',
                'Required parameter "instituteId" was null or undefined when calling updateAppointment().'
            );
        }

        if (requestParameters['appointmentId'] == null) {
            throw new runtime.RequiredError(
                'appointmentId',
                'Required parameter "appointmentId" was null or undefined when calling updateAppointment().'
            );
        }

        if (requestParameters['appointmentRequest'] == null) {
            throw new runtime.RequiredError(
                'appointmentRequest',
                'Required parameter "appointmentRequest" was null or undefined when calling updateAppointment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['isMove'] != null) {
            queryParameters['isMove'] = requestParameters['isMove'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/institutes/{institute_id}/planning/{appointment_id}`.replace(`{${"institute_id"}}`, encodeURIComponent(String(requestParameters['instituteId']))).replace(`{${"appointment_id"}}`, encodeURIComponent(String(requestParameters['appointmentId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppointmentRequestToJSON(requestParameters['appointmentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppointmentResponseFromJSON(jsonValue));
    }

    /**
     * Update an appointment
     */
    async updateAppointment(requestParameters: UpdateAppointmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppointmentResponse> {
        const response = await this.updateAppointmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
